import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from '../shared/notification-dialog/notification-dialog.component';

@Injectable({
  providedIn: 'root',
})

export class NotificationService {
  constructor(public snackBar: MatSnackBar,  
    private dialog: MatDialog, 
    private zone: NgZone) { }

  showSuccess(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'OK', {
        duration: 2000,
      });
    });
  }

  showError(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'X', { panelClass: ['error'] });
    });
  }

  showBusinessError(message: string): void {
    this.zone.run(() => {
      this.dialog.open(NotificationDialogComponent, {
        data: {
          message: message,
        },
      });
    });
  }
}
